import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)<{ color: string; bordered?: boolean }>`
    background-color: ${({ color }) => color ?? '#edf2f7'};
    border-radius: 5px;
    /* border: 1px solid #4B4748; */
    border-left: ${({ bordered }) => (bordered ? '3px solid #FF4D00' : 'none')};
`;
